// extracted by mini-css-extract-plugin
export default {"withoutPlanWrapper":"WithoutPlan_withoutPlanWrapper__onMAL","leftSide":"WithoutPlan_leftSide__oXM+M","rightSide":"WithoutPlan_rightSide__h2Ykk","logo":"WithoutPlan_logo__JYSXR"};